import React, { useState, useCallback, memo } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import NewEventModal from "../../Events/All-Events/NewEventModal/NewEventModal";
import "./Sidebar.css";

const Sidebar = memo(({ sidebarOpen, closeSidebar }) => {
  const currentDate = new Date();
  const navigate = useNavigate();

  // State for modal
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [reset, setReset] = useState(false);

  const closeModal = () => setIsModalOpen(false);
  
  const handleMenuClick = useCallback(() => {
    if (window.innerWidth <= 991) {
      closeSidebar();
    }
  }, [closeSidebar]);

  const handleDayCalendarClick = useCallback(() => {
    navigate(`/day-calendar/${currentDate.toISOString().split("T")[0]}`);
  }, [navigate, currentDate]);

  return (
    <>
      <div
        id="sidebar"
        className={`sidebar pe-0 pt-4 bg-blue ${sidebarOpen ? "open" : ""}`}
      >
        <nav className="navbar bg-light bg-blue">
          <a href="/" className="navbar-brand mx-5 mb-3">
            <h3 className="text-white">
              <img
                alt="..."
                style={{ width: "225px" }}
                src="/img/event-trackit-logo-white.svg"
              />
            </h3>
          </a>
          <div className="navbar-nav w-100 pt-5">
            <NavLink
              to={"/"}
              className="nav-item nav-link text-uppercase"
              activeclassname="active"
            >
              <i className="fa-solid fa-home me-3" /> Dashboard
            </NavLink>
            {/* We use NavLink so that we can use active route class. */}
            <div className="nav-item dropdown">
              <Link
                href="#"
                className="nav-link dropdown-toggle text-uppercase"
                data-bs-toggle="dropdown"
              >
                <i className="fa-solid fa-calendar-days me-3" />
                Calendar
              </Link>
              <div className="dropdown-menu border-0 m-0 p-0" id="bg-dropdown">
                <Link to="/month-calendar" onClick={handleMenuClick} className="dropdown-item nav-link">
                  Month View
                </Link>
                <Link onClick={handleDayCalendarClick} className="dropdown-item nav-link">
                  Day View
                </Link>
              </div>
            </div>
            <NavLink
              to={"/templates"} onClick={handleMenuClick}
              className="nav-item nav-link text-uppercase"
              activeclassname="active"
            >
              <i className="fa-solid fa-briefcase me-3" /> Templates
            </NavLink>
            <div className="nav-item dropdown">
              <Link
                href="#"
                className="nav-link dropdown-toggle text-uppercase"
                data-bs-toggle="dropdown"
              >
                <i className="fa-solid fa-calendar-plus me-3" />
                Events
              </Link>
              <div className="dropdown-menu border-0 m-0 py-0" id="bg-dropdown">
                <Link
                  to="/events" onClick={handleMenuClick}
                  className="dropdown-item nav-link text-uppercase"
                >
                  View Events
                </Link>

                <a
                  href="#"
                  className="dropdown-item nav-link text-uppercase"
                  data-bs-toggle="modal"
                  data-bs-target="#staticBackdrop"
                  onClick={(e) => e.preventDefault()}
                >
                  New Event
                </a>
              </div>
            </div>
            <Link to="/gallery" onClick={handleMenuClick} className="nav-item nav-link text-uppercase">
              <i className="fa-solid fa-images me-3" />
              Gallery
            </Link>{" "}
          </div>
        </nav>
      </div>

      {/* New Event Modal */}
      <NewEventModal
        isOpen={isModalOpen}
        onClose={closeModal}
        curDate={""}
        reset={reset}
      />
    </>
  );
});

export default Sidebar;
